import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * **Hart PMS**
 *
 * @exports bs_429
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     *
     * @memberOf module:bs_429
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot() {
    const container = document.body;
    if (container) {
      let refreshPage = thn.debounce(thn.pageCheck, 800);

      thn.observeDom(container, refreshPage, {
        attributes: true,
      });

      thn.shutdown(() => {
        refreshPage.cancel();
        thn.stopObserveDom(container, refreshPage);
        refreshPage = null;
      });
    }

  };
  /**
     * @memberOf module:bs_429
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {
      reject('no_language');
    });
  };

  /**
    *
    * @memberOf module:bs_429
    *
    */
  const roomDetailsParseData = (numAdults, numChildren) => {
    const roomsArray = [...document.querySelectorAll('.detailsContainer')];

    if (thn.empty(roomsArray)) {
      return {};
    }

    const roomsInfo = roomsArray
      .map((room) => {
        const roomName = room.querySelector('.detailTitle')?.textContent?.trim();
        const roomType = getRoomType(roomName);
        const ratesInfo = [...room.querySelectorAll('.rateContainer')]
          ?.map((rate) => {
            const rateName = rate.querySelector('.rateTitle h5 span')?.textContent?.trim();
            const ratePrice = thn.parseNumber(rate.querySelector('.priceToSelect')?.textContent);
            const rateData = {
              id: '',
              name: rateName,
              totalNight: ratePrice,
              breakfast: true,
              refundable: false,
            };

            return rateData;
          });

        const roomData = {
          id: '',
          name: roomName,
          adults: numAdults || 2,
          children: numChildren || 0,
          type: roomType,
          prices: ratesInfo,
        };

        return roomData;
      });

    return roomsInfo;
  };

  /**
     * @memberOf module:bs_429
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    // https://marinehotelballycastle.cloud-reservations.net/BookHotel#searchRates
    const url = new URL(ctx.baseUrl);
    const validUrl = url.hostname.match(/cloud-reservations/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    // Export into ctx.newUrl
    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
     * @memberOf module:bs_429
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    // Dates
    const dateBegin = thn.dataLayerHelper.get('check_in_date')?.replace(/-/g, '/');
    const dateEnd = thn.dataLayerHelper.get('check_out_date')?.replace(/-/g, '/');
    let nights;

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
      nights = thn.daysBetween(dateBegin, dateEnd) || thn.parseNumber(thn.dataLayerHelper.get('stay_length'));
    }

    // Guests, Adults & Children
    widgetData.adults = thn.parseNumber(thn.dataLayerHelper.get('adults')) || 2;
    widgetData.children = thn.parseNumber(thn.dataLayerHelper.get('children')) || 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // Prices & Currency || No Rooms
    const prices = [...document.querySelectorAll('.priceNights b ,.rateDetailPrice')].map((price) => thn.parseNumber(price?.textContent)).filter(Boolean);
    const currency = thn.parseCurrency(document.querySelector('.ratePrice h5, .priceNights b ,.rateDetailPrice')?.textContent);
    const noAvailability = !!document.querySelector('.noRates');

    if (!thn.empty(prices) && currency && nights) {
      widgetData.price = Math.min(...prices) / nights;
      widgetData.currency = currency;
      widgetData.roomDetails = roomDetailsParseData(widgetData.adults, widgetData.children);
      widgetData.set = true;
    } else if (noAvailability) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_429
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const dataLayer = window.dataLayer;
    const bookingId = thn.objectGet(dataLayer, 'transaction_id') || thn.parseUrlParameter('cartID');

    if (!bookingId) {
      widgetData.set = false;
      return widgetData;
    }

    widgetData.dateBegin = thn.objectGet(dataLayer, 'check_in_date')?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    widgetData.dateEnd = thn.objectGet(dataLayer, 'check_out_date')?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    widgetData.price = thn.parseNumber(thn.objectGet(dataLayer, 'value')) || thn.parseNumber(thn.objectGet(dataLayer, 'transactionTotal'));
    widgetData.currency = thn.objectGet(dataLayer, 'currency') || thn.objectGet(dataLayer, 'transactionCurrency');
    widgetData.bookingId = bookingId;

    return widgetData;
  };

  return engine;

}

export { factory };
